export const IDCardTypes = [
  {
    value: '0',
    label: '身份证'
  },
  {
    value: '1',
    label: '护照'
  },
  {
    value: '2',
    label: '军人证'
  },
  {
    value: '3',
    label: '警官证'
  },
  {
    value: '4',
    label: '台胞证'
  },
  {
    value: '5',
    label: '港澳通行证'
  },
  {
    value: '6',
    label: '边境通行证'
  },
  {
    value: '7',
    label: '户口本号'
  },
  {
    value: '8',
    label: '其他'
  }
]
